import type {FC} from 'react';

import type {Props} from './types';

import {CountryFlag} from '../../../../uikit/CountryFlag';
import * as S from './styles';

export const ListItem: FC<Props> = ({code, name, ...rest}) => {
  return (
    <S.Container {...rest}>
      <CountryFlag countryCode={code} />
      <S.Name>{name}</S.Name>
    </S.Container>
  );
};
